import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { NavigationState } from "./navigationTypes";

const initialState: NavigationState = {
  portfolio: null,
  account: null,
  quoteAsset: null,
  view: null,
  symbol: null,
};

const navigationSlice = createSlice({
  name: "navigation",
  initialState,
  reducers: {
    setPortfolio: (state, action: PayloadAction<string>) => {
      state.portfolio = action.payload;
    },
    clearPortfolio: (state) => {
      state.portfolio = null;
    },
    setAccount: (state, action: PayloadAction<string>) => {
      state.account = action.payload;
    },
    clearAccount: (state) => {
      state.account = null;
    },
    setQuoteAsset: (state, action: PayloadAction<string>) => {
      state.quoteAsset = action.payload;
    },
    clearQuoteAsset: (state) => {
      state.quoteAsset = null;
    },
    setView: (state, action: PayloadAction<string>) => {
      state.view = action.payload;
    },
    clearView: (state) => {
      state.view = null;
    },
    setSymbol: (state, action: PayloadAction<string>) => {
      state.symbol = action.payload;
    },
    clearSymbol: (state) => {
      state.symbol = null;
    },
    clearNavigation: (state) => {
      state.portfolio = null;
      state.account = null;
      state.quoteAsset = null;
      state.view = null;
      state.symbol = null;
    },
  },
});

export const {
  setPortfolio,
  clearPortfolio,
  setAccount,
  clearAccount,
  setQuoteAsset,
  clearQuoteAsset,
  setView,
  clearView,
  setSymbol,
  clearSymbol,
  clearNavigation,
} = navigationSlice.actions;

export default navigationSlice.reducer;
